{
  "TYPE": "Type",
  "VOUCHER": "Voucher",
  "DATE": "Date",
  "DEFECT": "Defect",
  "VOUCHER_TYPE": "Voucher Type",
  "ALL": "All",
  "RETURN": "Return",
  "TRANSPORT_ORDER": "Transport Order",
  "PICKING": "Picking",
  "SALES_ORDER": "Sales Order",
  "DELIVERY_NOTE": "Delivery Note",
  "RECONDITIONING_ORDER": "Reconditioning Order",
  "PURCHASE_ORDER": "Purchase Order",
  "CONDITION": "Condition",
  "OK": "Ok",
  "IS_RELEVANT": "Is Relevant",
  "SHOW_IS_RELEVANT": "Show relevant",
  "BRANCH": "Branch",
  "VOUCHER_NUMBER": "Voucher Number",
  "ARTICLE_NUMBER": "Item Number",
  "COMMENT": "Comment",
  "CREATION_DATE": "Creation Date",
  "CUSTOMER_NAME": "Customer Name",
  "CUSTOMER_NUMBER": "Customer Number",
  "SITE_NUMBER": "Site Number",
  "SUB_SITE_NUMBER": "Sub Site Number",
  "SUB_SUB_SITE_NUMBER": "Sub Sub Site Number",
  "PROJECT_NUMBER": "Project Number",
  "VOUCHER_DATE": "Voucher Date",
  "DAMAGE": "Damage",
  "YES": "Yes",
  "NO": "No",
  "NONE": "None",
  "LOADING": "Loading",
  "LOGIN": "Login",
  "CHANGE_VOUCHER_NUMBER": "Change Voucher Number",
  "CHANGE": "Change",
  "CANCEL": "Cancel",
  "UNKNOWN_VOUCHER_NUMBER": "Unkown Voucher Number",
  "UNKNOWN_VOUCHER_NUMBER_TEXT": "Your entered voucher number is unkown. Please refresh the webpage to see the new details",
  "NO_IMAGES": "No Images",
  "SALES_IDS": "Sales Ids",
  "SET_IS_RELEVANT": "Set as relevant",
  "UNSET_IS_RELEVANT": "Unset as relevant",
  "DELETE_PICTURE": "Delete picture",
  "SUCCESSFULLY_CHANGED_IS_RELEVANT": "Successfully changed is relevant",
  "SUCCESSFULLY_CHANGED_IS_RELEVANT_TEXT": "You have successfully changed the is relevant flag",
  "DELETE_PICTURE_TEXT": "Do you really want to delete this picture?",
  "DELETE": "Delete",
  "SELECT": "Select",
  "STOP": "Stop",
  "SET_RELEVANT": "Set Relevant",
  "DELETING": "Deleting",
  "SETTING_RELEVANT": "Setting relevant",
  "CHANGING_VOUCHER": "Changing voucher",
  "TOTAL_IMAGE_COUNT": "Total image count",
  "DOWNLOAD_IMAGES": "Download images",
  "DOWNLOADING": "Downloading",
  "ERROR": "Error",
  "ERROR_DOWNLOADING_IMAGES": "Error downloading images",
  "SORT_DATE": "Sort date",
  "ASCENDING": "Ascending",
  "DESCENDING": "Descending",
  "ERROR_ROTATING_IMAGE": "Rotating image on backend failed.",
  "SUCCESSFULLY_CHANGED_VOUCHER_NUMBER": "Successfully changed voucher number",
  "SUCCESSFULLY_CHANGED_VOUCHER_NUMBER_TEXT": "You have successfully changed this image's voucher number",
  "SEARCH_PLACEHOLDER": "Enter the exact voucher or sales number you are searching for",
  "SEARCH": "Search",
  "DATE_FILTER_SELECT": "Select Date Range",
  "DATE_PICKER_DONE": "Done",
  "UPLOADING": "Uploading",
  "DOWNLOAD": "Download",
  "UPLOAD": "Upload",
  "DELETE_DOCUMENT": "Delete Document?",
  "DELETE_DOCUMENT_TEXT": "Do you really want to delete this document?",
  "UPLOAD_NEW_DOCUMENT": "Upload new document",
  "CHOOSE_DOCUMENT": "Choose Document",
  "UPLOAD_NEW_DOCUMENT_TITLE": "Upload new document:",
  "PICTURES": "Pictures",
  "DOCUMENTS": "Documents",
  "NAME": "Name",
  "FILE_TOO_BIG": "File too big. Open this document with the button below.",
  "UPLOAD_ALERT_HEADER": "Upload new document",
  "ERROR_VOUCHER_NOT_FOUND": "Voucher not found.",
  "ERROR_UPLOAD_ERROR": "Document could not be uploaded.",
  "ERROR_UNKNOWN_ERROR": "An unknown error occured.",
  "OWN_DOCUMENTS": "Own Documents",
  "NO_DOCUMENTS": "No Documents found",
  "CREATOR": "Creator",
  "LAST_MODIFIER": "Last Modifier",
  "LAST_MODIFIED": "Last Modified",
  "CHOOSE_VOUCHER_TYPE": "Choose voucher type",
  "ERROR_LOADING_DOCUMENT": "Error loading document.",
  "UPDATE": "Update",
  "UPLOAD_SUCCESSFUL": "Upload successfull",
  "UPLOAD_SUCCESSFUL_TEXT": "Your document was successfully uploaded.",
  "UNSUPPORTED_FORMAT": "Unsupported format",
  "UNSUPPORTED_FORMAT_TEXT": "Only .docx, .pdf, .jpeg, .png and emails(.msg) are supported",
  "UPLOAD_IMAGE_SUCCESSFUL": "Upload successfull",
  "UPLOAD_IMAGE_SUCCESSFUL_TEXT": "Your image was successfully uploaded.",
  "UNSUPPORTED_IMAGE_FORMAT": "Unsupported format",
  "UNSUPPORTED_IMAGE_FORMAT_TEXT": "Only .jpg/.jpeg, .png and .gif are supported",
  "UPLOAD_IMAGE_ALERT_HEADER": "Upload Image",
  "DROP_TO_UPLOAD": "Drop to upload",
  "IMAGE_ARCHIVED": "Image archived - please request re-load via HD-Ticket \"DOT: YardCam Pictures Document number XXX\"",
  "UNARCHIVE_IMAGES": "Unarchive images",
  "UNARCHIVING_IMAGES": "Unarchiving images",
  "PROCESS_STEP": "Process step",
  "WORKPLACE": "Workplace",
  "Unloading": "Unloading",
  "FirstCount": "First count",
  "Grading": "Grading",
  "Picking": "Picking",
  "PickingCheck": "Picking check",
  "Loading": "Loading",
  "LoadingCheck": "Loading check",
  "ARCHIVED_IMAGES_WARNING_TITLE": "Archived pictures!",
  "ARCHIVED_IMAGES_WARNING_DESCRIPTION": "Some of the pictures you selected are archived. Archived pictures will not be included in your download. Please check your selected pictures. If you need an archived picture, please write an HD ticket.",
  "DOWNLOAD_AVAILABLE_PICTURES": "Download Available Pictures",
  "FAILED_TO_DOWNLOAD_ZIP_TITLE": "Failed to download zip",
  "FAILED_TO_DOWNLOAD_ZIP_MESSAGE": "There was an error downloading the pictures. Please try again later.",
  "LOGOUT": "Logout"
}
